// components/ProductRoute.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './navigation/Navigation';
import Notifications from './notifications/Notifications';
import { AppProvider } from '../context/AppContext';
const ProductRoute = () => {
	return (
		<AppProvider>
			<div className="flex h-screen">
				<Navigation />
				<Notifications />
				<main id="main-content" className="flex-1 overflow-auto">
					<Outlet />
				</main>
			</div>
		</AppProvider>
	);
};

export default ProductRoute;
